<sw-card
    :title="$tc('TopdataContactLoginSW6.admin.contactsCardTitle')"
    :isLoading="isLoading">

    <template #toolbar>
        <sw-button
            variant="primary"
            size="small"
            @click="onAddContact">
            {{ $tc('TopdataContactLoginSW6.admin.addContact') }}
        </sw-button>
    </template>

    <sw-data-grid
        :dataSource="contacts"
        :columns="columns"
        :showSelection="false"
        :allowInlineEdit="false"
        :allowColumnEdit="false"
        :compactMode="false">

        <template #column-firstName="{ item }">
            {{ item.firstName }} {{ item.lastName }}
        </template>

        <template #column-active="{ item }">
            <sw-icon
                v-if="item.active"
                name="regular-checkmark-xs"
                small
                color="#37d046">
            </sw-icon>
            <sw-icon
                v-else
                name="regular-times-s"
                small
                color="#de294c">
            </sw-icon>
        </template>

        <template #actions="{ item }">
            <sw-context-menu-item @click="onEditContact(item)">
                {{ $tc('global.default.edit') }}
            </sw-context-menu-item>
            <sw-context-menu-item variant="danger" @click="onDeleteContact(item)">
                {{ $tc('global.default.delete') }}
            </sw-context-menu-item>
        </template>

    </sw-data-grid>

    <sw-modal
        v-if="showContactModal"
        :title="currentContact.id ? $tc('TopdataContactLoginSW6.admin.editContact') : $tc('TopdataContactLoginSW6.admin.createContact')"
        variant="default"
        @modal-close="onCloseModal">

        <sw-container columns="1fr 1fr" gap="16px">
            <sw-field
                v-model="currentContact.email"
                type="text"
                :label="$tc('TopdataContactLoginSW6.admin.email')"
                validation="required">
            </sw-field>

            <sw-field
                v-model="currentContact.password"
                type="password"
                :label="$tc('TopdataContactLoginSW6.admin.password')"
                :helpText="currentContact.id ? $tc('TopdataContactLoginSW6.admin.passwordHelp') : ''">
            </sw-field>
        </sw-container>

        <sw-container columns="1fr 1fr" gap="16px">
            <sw-field
                v-model="currentContact.firstName"
                type="text"
                :label="$tc('TopdataContactLoginSW6.admin.firstName')"
                validation="required">
            </sw-field>

            <sw-field
                v-model="currentContact.lastName"
                type="text"
                :label="$tc('TopdataContactLoginSW6.admin.lastName')"
                validation="required">
            </sw-field>
        </sw-container>

        <sw-field
            v-model="currentContact.defaultBillingAddressId"
            type="select"
            :label="$tc('TopdataContactLoginSW6.admin.defaultBillingAddress')"
            :placeholder="$tc('TopdataContactLoginSW6.admin.selectAddress')">
            <option value="">{{ $tc('TopdataContactLoginSW6.admin.noAddress') }}</option>
            <option v-for="address in customerAddresses" :key="address.id" :value="address.id">
                {{ getAddressLabel(address) }}
            </option>
        </sw-field>

        <sw-field
            v-model="currentContact.defaultShippingAddressId"
            type="select"
            :label="$tc('TopdataContactLoginSW6.admin.defaultShippingAddress')"
            :placeholder="$tc('TopdataContactLoginSW6.admin.selectAddress')">
            <option value="">{{ $tc('TopdataContactLoginSW6.admin.noAddress') }}</option>
            <option v-for="address in customerAddresses" :key="address.id" :value="address.id">
                {{ getAddressLabel(address) }}
            </option>
        </sw-field>

        <sw-field
            v-if="currentContact.id"
            v-model="currentContact.active"
            type="switch"
            :label="$tc('TopdataContactLoginSW6.admin.active')">
        </sw-field>

        <template #modal-footer>
            <sw-button @click="onCloseModal" size="small">
                {{ $tc('global.default.cancel') }}
            </sw-button>
            <sw-button variant="primary" @click="onSaveContact" size="small">
                {{ $tc('global.default.save') }}
            </sw-button>
        </template>

    </sw-modal>

    <sw-delete-modal
        ref="contactDeleteModal"
        :title="$tc('TopdataContactLoginSW6.admin.deleteContactTitle')"
        :text="$tc('TopdataContactLoginSW6.admin.deleteContactText')"
        @confirm="onConfirmDeleteContact">
    </sw-delete-modal>

</sw-card>
